
import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
    selector: '[OnlyNumber]',
    providers: [NgModel]
})
export class OnlyNumber {

    constructor(private model: NgModel, private el: ElementRef) { }

    @Input() OnlyNumber: boolean;
    @Input() DecimalPlace: number;


    @HostListener('keydown', ['$event']) onKeyDown(event) {
        let e = <KeyboardEvent>event;
        let current: string = this.el.nativeElement.value;
        const position = this.el.nativeElement.selectionStart;
        const next: string = [current.slice(0, position), event.key, current.slice(position)].join('');
        if (this.OnlyNumber) {
            if ([46, 8, 9, 27, 13, 190].indexOf(e.keyCode) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: Ctrl+C
                (e.keyCode == 67 && e.ctrlKey === true) ||
                // Allow: Ctrl+X
                (e.keyCode == 88 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)) {
                // let it happen, don't do anything
                return;
            }
            //if (parseInt(this.inputval + e.key) > parseInt(this.maxval) || parseInt(this.inputval + e.key) <= parseInt(this.minval)) {
            //    e.preventDefault();
            //}

            if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode != 110) {
                e.preventDefault();
            }

            if (this.DecimalPlace && next && (next.toString()).split('.').length &&
                (next.toString()).split('.')[1] &&
                (next.toString()).split('.')[1].length > this.DecimalPlace) {
                e.preventDefault();
            }
            if (next && ((next.toString()).split('.').length) > 2) {
                e.preventDefault();
            }
            // Ensure that it is a number and stop the keypress

        }
    }
}


/*
Copyright 2016 Google Inc. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at http://angular.io/license
*/